import { classNameWithModifier } from '@slickdeals/durango/dist/javascript/utilities/css';
import BlueprintComponent from '../core/blueprintComponent';
import './iconFont';
import '../../scss/components/icon.scss';
/** The name of the module */
export const name = 'Icon';
/** Class names for the component */
export const ClassNames = {
    default: 'bp-c-icon',
};
class Icon extends BlueprintComponent {
    /**
       * Builds an span element that will load the desired icon once injected
       *
       * @param iconName The name of the icon to create HTMLSpanElement for
       *
       * @returns {IconElement}
       */
    static createElement(options) {
        const [, iconName, iconSize] = /^([a-zA-Z]+)(?:--([a-z]+))?$/.exec(options.name);
        // Force proper icon naming
        if (!iconName) {
            throw new Error(`Icon name is not valid: ${options.name}`);
        }
        const classNames = [ClassNames.default];
        // If iconName includes --, add on the required class names so the icon is sized appropriately
        if (iconSize) {
            classNames.push(Icon.buildIconClassName(iconName), classNameWithModifier(ClassNames.default, iconSize));
            // iconClasses.push(`bp-i-${iconInfo[0]}`, classNameWithModifier  `bp-i-icon--${iconInfo[1]}`);
        }
        else {
            // Else, just add the base icon class with default sizing
            classNames.push(Icon.buildIconClassName(options.name));
        }
        // Create the span element which will contain the icon information
        const element = document.createElement('span');
        // Add on all classes for said icon
        element.classList.add(...classNames, ...(options.classNames ?? []));
        return element;
    }
    /**
       * Build class name for an icon
       *
       * @param iconName Icon name slug (e.g. arrow, close, etc)
       */
    static buildIconClassName(iconName) {
        return `bp-i-${iconName}`;
    }
}
export default Icon;
